import { render, staticRenderFns } from "./Pans.vue?vue&type=template&id=4aee914b&"
import script from "./Pans.vue?vue&type=script&lang=js&"
export * from "./Pans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports